"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";

interface CartEmptyStateProps {
  message?: string;
  continueShoppingHref?: string;
  className?: string;
}

export function CartEmptyState({
  message = "Your cart is empty.",
  continueShoppingHref,
  className,
}: CartEmptyStateProps) {
  return (
    <div className={className}>
      <ShoppingCart className="w-16 h-16 mx-auto text-muted-foreground mb-2" />
      <p className="text-foreground/60">{message}</p>
      {continueShoppingHref && (
        <Link href={continueShoppingHref}>
          <Button className="mt-3 bg-primary text-primary-foreground">
            Continue shopping
          </Button>
        </Link>
      )}
    </div>
  );
}
